import { MAX_TOTAL_EXCEEDED, MIN_AMOUNT_REMAINING_NOT_REACHED, MIN_TOTAL_NOT_REACHED } from '../../constants/ValidationErrors';
import { AMOUNT_REMAINING_LESS_THAN_MIN, PAYMENT_AMOUNT_GREATER_THAN_MAX, PAYMENT_AMOUNT_LESS_THAN_MIN } from '../../constants/PaymentAmount';
function getThresholdAmount(error) {
  var _error$context;
  const rawThreshold = error === null || error === void 0 || (_error$context = error.context) === null || _error$context === void 0 || (_error$context = _error$context.validationThreshold) === null || _error$context === void 0 ? void 0 : _error$context[0];
  const thresholdAmount = rawThreshold ? Number(rawThreshold) : undefined;
  const safeThreshold = thresholdAmount && !isNaN(thresholdAmount) ? thresholdAmount : undefined;
  return safeThreshold;
}
function getPaymentAmountValidationError(validationErrorsMap) {
  const minTotalError = validationErrorsMap[MIN_TOTAL_NOT_REACHED];
  if (minTotalError) {
    const thresholdAmount = getThresholdAmount(minTotalError);
    return {
      validationError: PAYMENT_AMOUNT_LESS_THAN_MIN,
      thresholdAmount,
      messageKey: 'payments.partialPayments.amountBelowMsg_jsx'
    };
  }
  const maxTotalError = validationErrorsMap[MAX_TOTAL_EXCEEDED];
  if (maxTotalError) {
    const thresholdAmount = getThresholdAmount(maxTotalError);
    return {
      validationError: PAYMENT_AMOUNT_GREATER_THAN_MAX,
      thresholdAmount,
      messageKey: 'payments.partialPayments.amountAboveMsg_jsx'
    };
  }
  const minAmountRemainingError = validationErrorsMap[MIN_AMOUNT_REMAINING_NOT_REACHED];
  if (minAmountRemainingError) {
    const thresholdAmount = getThresholdAmount(minAmountRemainingError);
    return {
      validationError: AMOUNT_REMAINING_LESS_THAN_MIN,
      thresholdAmount,
      messageKey: 'payments.partialPayments.amountRemainingBelowMin_jsx'
    };
  }
  return {
    validationError: null,
    thresholdAmount: undefined,
    messageKey: null
  };
}
export default getPaymentAmountValidationError;